export class CalibrationParameterRanges {
  /* ---------------------------- SHARED ---------------------------- */

  static readonly NAME = {
    min: 2,
    max: 16,
  };

  static readonly R2 = {
    min: 0,
    max: 1,
    step: 0.1,
    default: 1,
  };

  /* ---------------------------- OD ---------------------------- */

  static readonly OD_OFFSET = {
    min: -10000,
    max: 10000,
    step: 10,
    default: 202.21,
    belowRangeWarning: 0,
    warningMessage: 'Warning: Offset is outside of recommended range',
  };

  static readonly OD_FACTOR = {
    min: 0,
    max: 20000,
    step: 100,
    default: 2085.17,
  };

  static readonly OD_POWER = {
    min: 0,
    max: 2,
    step: 0.1,
    default: 0.7504,
    aboveRangeWarning: 1,
    warningMessage: 'Warning: Power is outside of recommended range',
  };

  static readonly OD_TEMPERATURE = {
    min: 0,
    max: 100,
    step: 1,
    default: 37,
  };

  /* ---------------------------- Oxygen ---------------------------- */

  static readonly OXYGEN_DPHI_0 = {
    min: 0,
    max: 100,
    step: 1,
    default: 54,
  };

  static readonly OXYGEN_DPHI_100 = {
    min: 0,
    max: 100,
    step: 1,
    default: 20.5,
  };

  static readonly OXYGEN_TEMPERATURE_0 = {
    min: 0,
    max: 100,
    step: 1,
    default: 20,
  };

  static readonly OXYGEN_TEMPERATURE_100 = {
    min: 0,
    max: 100,
    step: 1,
    default: 20,
  };

  static readonly OXYGEN_PRESSURE = {
    min: 0,
    max: 2000,
    step: 10,
    default: 1000,
  };

  /* ---------------------------- pH ---------------------------- */

  static readonly PH_OFFSET = {
    min: -100,
    max: 1000,
    step: 1,
    default: 0,
    belowRangeWarning: 0,
    warningMessage: 'Warning: Offset is outside of recommended range',
  };

  static readonly PH_TEMPERATURE = {
    min: 0,
    max: 100,
    step: 1,
    default: 20,
  };

  static readonly PH_SLOPE = {
    min: 0,
    max: 200,
    step: 1,
    default: 100,
    belowRangeWarning: 90,
    aboveRangeWarning: 100,
    warningMessage: 'Warning: Slope rate is outside of recommended range',
  };

  /* ---------------------------- Sparging ---------------------------- */

  static readonly SPARGING_INTERCEPT = {
    min: -100,
    max: 100,
    step: 10,
    default: 0,
  };

  static readonly SPARGING_SLOPE = {
    min: 0,
    max: 200,
    step: 10,
    default: 100,
  };
}
